import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ClientModel } from '../../../shared/models/client.model';
import { ClientService } from '../../../shared/services/client.service';
import { Page } from '../../../shared/models/page.model';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../shared/services/auth.service';
import { ModalDirective } from 'ngx-bootstrap';
import { MessageService } from '../../../@pages/components/message/message.service';
import { Utils } from '../../../shared/services/utils.service';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {


  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;

  freeSearch: string;
  clients: ClientModel[];
  ColumnMode = ColumnMode;
  page: Page = new Page();
  currentPage = 1;
  columns = [];
  rows = [];
  
  searchParams = { per_page: environment.per_page, page: this.currentPage };

  constructor(
    private router: Router,
    private clientService: ClientService,
    private authService: AuthService,
    private messageService : MessageService,
    private utils : Utils,
    private route : ActivatedRoute
  ) {

    }

  ngOnInit() {
    this.loadFilters();
    this.loadClients();
    this.columns = [
      { name: 'Name', flexGrow: 1, sortable: true, cellClass: 'client_name', headerClass: 'client_name' },
      { name: 'Email', flexGrow: 3, sortable: true, cellClass: 'client_email', headerClass: 'client_email' }
    ];
    this.updateMenuItems();
    
    let _this = this;
    this.historyChange.subscribe(res => {//If need to refresh on same page use this.
      // _this.loadFilters();
      // _this.loadClients();
    });
  }

  onSort(event) {
    this.searchParams['order_by'] = event['column']['prop'];
    this.searchParams['order_asc_desc'] = event['newValue'];
    this.loadClients();
  }

  loading = {
    isFirstLoad:false,
    isLoading:false
  };

  isLoading:boolean = false;

  loadClients() {
    let _this = this;
    _this.clients = [];
    if(!_this.loading.isFirstLoad){
      _this.loading.isFirstLoad = true;
      _this.loading.isLoading = true; 
    }
    _this.isLoading = true;
    this.clientService.getAll(this.searchParams).subscribe(res => {
      res['meta']['per_page'] = +res['meta']['per_page']; 
      _this.page = res['meta'];
      _this.clients = res['data'];
      _this.rows = [];
      //console.log(res['data']['data'])
      for (let client of _this.clients) {
        _this.rows.push(
          {
            id: client.id,
            name: client.first_name+(client.last_name ? ' '+client.last_name : ''),
            email: client.email ? client.email : 'Email Not Set',
          }
        );
      }
      if(res['data'].length == 0){
        //this.messageService.error("No Guests Found.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
      }
      console.log(_this.page);
      _this.isLoading = false;
      _this.loading.isLoading = false;
    },
    err => {
      _this.isLoading = false;
      _this.loading.isLoading = false;
      console.log(err);
    });
  }

  hasPermission(permission){
    return this.authService.hasPermission(permission);
  }

  setPage(pageInfo) {
    this.currentPage = pageInfo.offset + 1;
    //console.log(pageInfo);
    this.searchParams.page = this.currentPage;
    //console.log(this.currentPage);
    this.loadClients();
    this.setFilter("pageClient",""+this.currentPage);
  }

  ngAfterViewInit() {
    this.table.bodyComponent.updatePage = function (direction: string): void {
      let offset = this.indexes.first / this.pageSize;

      if (direction === 'up') {
        offset = Math.ceil(offset);
      } else if (direction === 'down') {
        offset = Math.floor(offset);
      }

      if (direction !== undefined && !isNaN(offset)) {
        this.page.emit({ offset });
      }
    }
  }

  clearFilters() {
    this.freeSearch = "";
    this.updateFilters();
  }

  historyChange:EventEmitter<boolean> = new EventEmitter<boolean>();
  filteredParams:any = {};
  filterUpdateTimeout:any;
  setFilter(name, value) {
    let _this = this;
    _this.filteredParams = {..._this.filteredParams,[name]:value};
    this.utils.pushFiltersToRouter(value,name,_this.filteredParams).subscribe(res => {
      window.history.pushState(null,"",("guest"+res));
      _this.historyChange.emit(true);
    });
  }

  getFilter(name): any {
    let value = this.route.snapshot.queryParams[name];
    if(isNaN(+value)){
      return value;
    }
    return +value;
  }

  saveFilters() {
    let _this = this;
    setTimeout(() => {
      localStorage.removeItem("searchClient");
      _this.setFilter("pageClient", _this.currentPage);
      _this.setFilter("searchClient", _this.freeSearch);
    }, 250);
  }

  loadFilters(skipUpdate?) {
    this.freeSearch = this.getFilter("searchClient");
    this.currentPage = (this.getFilter("pageClient") ? this.getFilter("pageClient") : 1);
    if(!skipUpdate){
      this.updateFilters();
    }
  }

  filterLoadTimeout:any
  updateFilters(skip?) {
    let _this = this;
		_this.searchParams = { per_page: environment.per_page, page: 1 };
		if (!skip) {
		_this.searchParams.page = _this.currentPage;
		}
		else {
		_this.currentPage = 1;
		_this.setFilter("pageClient", 1);
		}
    if (this.freeSearch) {
      this.searchParams['q'] = this.freeSearch;
    }
    if (this.filterLoadTimeout) {
			clearTimeout(this.filterLoadTimeout);
		}
		this.filterLoadTimeout = setTimeout(() => {
			this.loadClients();
		}, 350);
    this.saveFilters();
  }


  //List Dot Menu Bulk Selection

  @ViewChild('mdSlideUp', { static: true }) mdSlideUp: ModalDirective;
  openBulk() {
    this.mdSlideUp.show()
  }

  mainToggle: boolean = false;
  activeActionTitle: string;
  menuItems: any[] = [
    { action: 'export-selected', message: 'Export Selected', class: '', icon: 'fal fa-file-export', permissions: ['view_guest'] },
    { action: 'export-all', message: 'Export All', class: '', icon: 'fal fa-file-export', permissions: ['view_guest'] },
  ];

  handleButtonPress(event) {
    switch (event) {
      case "export-selected":
        this.activeActionTitle = "Export Selected";
        this.openBulk();
        break;
      case "export-all":
        this.activeActionTitle = "Export All";
        this.openBulk();
        break;
      default:
        console.log(event);
        break;
    }
  }

  
  activeRows:Map<number,any> = new Map<number,any>();
  toggle(row) {
    row['bulk_checked'] = !row['bulk_checked'];
    let _this = this;
    if(row['bulk_checked']){
      _this.activeRows.set(row['id'],row);
    }
    else{
      _this.activeRows.delete(row['id']);
    }
    this.updateMenuItems();
  }

  isToggled = (row) => {
    return this.activeRows.has(row['id']);
  }

  updateMenuItems(){
    for(let item of this.menuItems){
      if(this.activeRows.size == 0){
        if(item.action.includes('export-selected')){
          item.Disabled = true;
        }
      }
      else{
        if(item.action.includes('export-selected')){
          item.Disabled = false;
        }
      }
    }
    return this.menuItems;
  }

  toggleAll() {
    let _this = this;
    this.mainToggle = !this.mainToggle;
    for (let item of _this.rows) {
      if(this.mainToggle == true){
        _this.activeRows.set(item.id,item);
      }
      else{
        _this.activeRows.delete(item.id);
      }
    }
    this.updateMenuItems();
  }

  submitToggle() {
    this.utils.submitToggle(this.activeActionTitle, this.messageService, this.searchParams, Array.from(this.activeRows.values()), 'client');
    this.activeRows = new Map<number,any>();
  }

}